// Soma, por item não-simples do pedido, a quantidade total das sizes convertida em material
// (mesma fórmula do totalMaterialConsumed() em FormBudgetItem.js: qty×measure pra "m", qty/measure pra "kg" —
// replicada aqui em vez de compartilhada, pra não mexer naquele arquivo de precificação por uma tela só de leitura).
//
// Além do tecido, também soma o consumo de aviamento (item.aviamentos, flattenado do Product do
// mesmo jeito que item.cloth/item.measure já são) — cada grupo do resultado vem marcado com
// `type: 'cloth' | 'aviamento'` pra quem renderiza distinguir os dois.
export default function buildPurchaseSummary(order) {
    const clothGroups = {}
    const aviamentoGroups = {}

    ;(order.orderItemArray || []).forEach((item) => {
        if (item.simpleProduct) return

        const qty = (item.sizes || []).reduce((acc, s) => acc + (parseInt(s.quantity) || 0), 0)
        if (!qty) return

        if (item.cloth && item.provider && item.unit && item.measure) {
            const measure = parseFloat(item.measure) || 0
            const material = item.unit.value === 'm' ? qty * measure : (measure ? qty / measure : 0)

            // Um item pode ter mais de uma cor selecionada, mas a quantidade não é dividida por cor no
            // modelo de dados — nesse caso (raro) as cores ficam listadas juntas no mesmo grupo, sem
            // fabricar uma divisão que a gente não tem como saber se está certa.
            const colorNames = (item.colors || []).map((c) => c.name).filter(Boolean)
            const colorKey = (item.colors || []).map((c) => c._id).sort().join(',')
            const colorLabel = colorNames.length ? colorNames.join(' / ') : 'Sem cor definida'

            const key = `${item.cloth._id}_${item.provider._id}_${item.unit.value}_${colorKey}`
            if (!clothGroups[key]) {
                clothGroups[key] = {
                    type: 'cloth',
                    clothId: item.cloth._id,
                    clothName: item.cloth.name,
                    providerId: item.provider._id,
                    providerName: item.provider.name,
                    colorLabel: colorLabel,
                    unit: item.unit,
                    unitLabel: item.unit.label || item.unit.value,
                    total: 0,
                }
            }
            clothGroups[key].total += material
        }

        ;(item.aviamentos || []).forEach((entry) => {
            if (!entry.aviamento || !entry.quantityPerPiece) return
            const qtyPerPiece = parseFloat(entry.quantityPerPiece) || 0
            if (!qtyPerPiece) return

            const key = entry.aviamento._id
            if (!aviamentoGroups[key]) {
                aviamentoGroups[key] = {
                    type: 'aviamento',
                    aviamentoId: entry.aviamento._id,
                    aviamentoName: entry.aviamento.name,
                    unit: entry.aviamento.unit,
                    unitLabel: entry.aviamento.unit?.label || entry.aviamento.unit?.value,
                    total: 0,
                }
            }
            aviamentoGroups[key].total += qty * qtyPerPiece
        })
    })

    return [...Object.values(clothGroups), ...Object.values(aviamentoGroups)]
}
